function readTipsShareFrontendUrl(): string | null {
  const frontendUrl = import.meta.env.VITE_FRONTEND_URL?.trim();

  return frontendUrl ? frontendUrl : null;
}

export function resolveTipsShareQrUrl(
  walletUUID: string | null,
): string | null {
  if (!walletUUID) {
    return null;
  }

  const frontendUrl = readTipsShareFrontendUrl();

  if (!frontendUrl) {
    return null;
  }

  return new URL(`/tip/${walletUUID}`, frontendUrl).toString();
}
